import { TokenAmount } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { BidderContext } from '../../Contexts'
import { Property } from '../Property'

const CurrencyBalanceProperty: React.FC = () => {
  const { currentBalance } = useContext(BidderContext)

  return (
    <Property title="XYO Balance" value={currentBalance?.toString(10)}>
      <TokenAmount amount={currentBalance} />
    </Property>
  )
}

export default CurrencyBalanceProperty
